import { render, staticRenderFns } from "./auditPass.vue?vue&type=template&id=4897b8c3&scoped=true"
import script from "./auditPass.vue?vue&type=script&lang=js"
export * from "./auditPass.vue?vue&type=script&lang=js"
import style0 from "./auditPass.vue?vue&type=style&index=0&id=4897b8c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897b8c3",
  null
  
)

export default component.exports